import React, { useEffect, useState } from "react";

import { Form, Upload, Avatar, Spin, App } from "antd";
import { faUser, faCamera, faMinus } from "@fortawesome/free-solid-svg-icons";
import { LoadingOutlined } from "@ant-design/icons";

import Icon from "../../Icon";
import { uploadFile } from "../../../pages/api/modules/User";
import { UIButton } from "../UIElements";

const antIcon = (
  <LoadingOutlined style={{ fontSize: 20, color: "white" }} spin />
);

const UIAvatar = ({
  setCountProgress = () => {},
  setPersonalInfoProgress = () => {},
  label,
  name,
  required,
  rules,
  index,
  onChange,
  validateStatus,
  hasFeedback,
  help,
  disabled,
  initialValue,
  defaultValue,
  persistSession = true,
  compact = false,
}) => {
  const [imageURL, setImageUrl] = useState(defaultValue || null);
  const [loading, setLoading] = useState(false);
  const { message } = App.useApp();
  const storageKey = `avatar_${name}`;

  const onUpload = async ({ fileList, file }) => {
    if(file.status === "done"){      
      setLoading(true);
      const url = URL.createObjectURL(fileList[0]?.originFileObj);
      if (fileList.length > 0) {
        const formData = new FormData();
        formData.append("file", fileList[0]?.originFileObj);
        const res = await uploadFile(formData);
  
  
        if (res?.Status === 1) {
          setImageUrl(url);
          setLoading(false);
          onChange(res?.Data?.Files?.FileName);
          if (persistSession) {
            sessionStorage.setItem(storageKey, url);
          }
        } else {
          message.error("Something went wrong");
        }
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!persistSession) {
      sessionStorage.removeItem(storageKey);
      setImageUrl(defaultValue || null);
      return;
    }

    const url = sessionStorage.getItem(storageKey);
    if (url) {
      setImageUrl(url);
    } else {
      setImageUrl(defaultValue || null);
    }
  }, [defaultValue, persistSession, storageKey]);

  const onRemove = (e) => {
    e.stopPropagation();
    setImageUrl(null);
    onChange(null);
    sessionStorage.removeItem(storageKey);
    setPersonalInfoProgress(prev => prev - 4);
setCountProgress(prev => prev - 4);

    
  };
  return (
   <div id= {`div_field_${name}`}>
     <Form.Item
      label={label}
      name={name}
      required={required}
      rules={rules}
      hasFeedback={hasFeedback}
      help={help}
      validateStatus={validateStatus}
      initialValue={defaultValue}
    >
      <div
        style={{
          height: compact ? 64 : 130,
          width: compact ? 64 : 130,
          borderRadius: 80,
          background: "#dae3ed",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          marginBottom: compact ? 0 : 25,
          position: "relative",
        }}
      >

        
        {imageURL ? (
          <Avatar
            style={{ backgroundColor: "white" }}
            size={compact ? 64 : 130}
            src={imageURL}
          />
        ) : (
          <Icon color="white" size={compact ? 27 : 55} Icon={faUser} />
        )}
        <Upload
        accept="image/*"
      onChange={onUpload}
      maxCount={1}
      showUploadList={false}
      onRemove={onRemove}
    >
      <div
        style={{
          height: compact ? 22 : 30,
          width: compact ? 22 : 30,
          borderRadius: 20,
          background: "rgba(0, 0, 0, 0.4)",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          position: "absolute",
          top: 1,
          right: compact ? 0 : 7,
        }}
        onClick={(e) => {
          if (imageURL) {
            onRemove(e);
          }
        }}
      >
        {loading ? (
          <Spin indicator={<Spin />} />
        ) : (
          imageURL ? (
            <Icon
              color="white"
              size={12}
              Icon={faMinus}
              
            />
          ) : (
            <Icon
              color="white"
              size={12}
              Icon={faCamera}
            />
          )
        )}
      </div>
    </Upload>
        
      </div>
    </Form.Item>
   
   
   
   </div>
  );
};

export default UIAvatar;
